import { render, staticRenderFns } from "./TopReferersTableCard.vue?vue&type=template&id=03e9cce2&scoped=true&"
import script from "./TopReferersTableCard.vue?vue&type=script&lang=ts&"
export * from "./TopReferersTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./TopReferersTableCard.vue?vue&type=style&index=0&id=03e9cce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e9cce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
